import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/advisor-appointments', config);
};

const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/advisor-appointments/excel-export', {
        ...config,
        responseType: 'blob'
    });
};

const updateStatus = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/coop/advisor-appointments/' + id + '/status', data);
};

const getAvailableSlots = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/advisor/available-slots', config);
};

const bookAppointment = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/advisor/appointments', data);
};

const getMe = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/advisor-appointments/me', config);
};

const remove = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/coop/advisor-appointments/' + id);
};

const getUnavailabilities = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/advisor/unavailabilities', config);
};

const storeUnavailability = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/advisor/unavailabilities', data);
};

const removeUnavailability = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/coop/advisor/unavailabilities/' + id);
};

export default {
    getAll,
    excelExport,
    updateStatus,
    getAvailableSlots,
    bookAppointment,
    getMe,
    remove,
    getUnavailabilities,
    storeUnavailability,
    removeUnavailability
};
